import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import "./Roadmaps.css";
import BackButton from "../../components/BackButton/BackButton.jsx";

function Roadmaps() {
  const [roadmaps, setRoadmaps] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoadmaps();
  }, []);

  const fetchRoadmaps = async () => {
    try {
      const res = await api.get("/roadmap/mine");
      const { roadmaps = [] } = res.data;
      setRoadmaps(roadmaps);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔥 SET CURRENT FUNCTION
  const setCurrentRoadmap = async (id) => {
    try {
      await api.patch(`/roadmap/set-current/${id}`);
      fetchRoadmaps(); // refresh UI
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="roadmaps-page">
      <div className="roadmaps-container">
      {/* Back button */}
      <div className="row-left">
        <BackButton to="/dashboard" label="Back to Dashboard" />
      </div>

        {/* Header */}
        <div className="roadmaps-header">
          <h1>Your Roadmaps</h1>

          <button
            className="create-roadmap-btn"
            onClick={() => navigate("/roadmap/create")}
          >
            + Create Roadmap
          </button>
        </div>

        {/* Empty state */}
        {roadmaps.length === 0 ? (
          <div className="roadmaps-empty">
            <h3>No Roadmaps Yet</h3>
            <p>Create a structured learning path for your goals.</p>

            <button
              className="create-roadmap-btn"
              onClick={() => navigate("/roadmap/create")}
            >
              Create Your First Roadmap
            </button>
          </div>
        ) : (
          <div className="roadmaps-grid">

            {roadmaps.map((roadmap) => (
              <div
                key={roadmap._id}
                className={`roadmap-list-card ${
                  roadmap.isCurrent ? "current-roadmap" : ""
                }`}
              >

                <div className="roadmap-card-header">
                  <h3>{roadmap.title}</h3>

                  <span className={`roadmap-badge ${roadmap.status}`}>
                    {roadmap.status}
                  </span>
                </div>

                {/* 🔥 CURRENT LABEL */}
                {roadmap.isCurrent && (
                  <div className="current-label">⭐ Current</div>
                )}

                <p>
                  {roadmap.status === "draft"
                    ? "Draft roadmap (not published)"
                    : `${roadmap.items?.length || 0} steps`}
                </p>

                <div className="roadmap-card-actions">

                  {/* Open / Edit */}
                  {roadmap.status === "draft" ? (
                    <button
                      onClick={() =>
                        navigate(`/roadmap/create?id=${roadmap._id}`)
                      }
                      className="open-roadmap-btn"
                    >
                      Continue Editing →
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        navigate(`/roadmap/${roadmap._id}`)
                      }
                      className="open-roadmap-btn"
                    >
                      Open →
                    </button>
                  )}

                  {/* 🔥 SET CURRENT BUTTON */}
                  {!roadmap.isCurrent && roadmap.status !== "draft" && (
                    <button
                      className="set-current-btn"
                      onClick={() => setCurrentRoadmap(roadmap._id)}
                    >
                      Set Current
                    </button>
                  )}

                </div>

              </div>
            ))}

          </div>
        )}

      </div>
    </div>
  );
}

export default Roadmaps;